import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Col from '../../utils/StyledCol'
import Row from '../../utils/StyledRow'
import styled from 'styled-components'
import AdvertSignWrapper from './AdvertSignWrapper'
import SashecAdvert from './SashecAdvert'
import { SIZES } from '../../../constants'
import Cookie from '../../../components/utils/Cookie'

const SashecAdvertPosition = styled.div`
  display: block;
  position: relative;
  margin: 0 0 20px 0;
  height: auto;
  
  @media (max-width: ${SIZES.BREAKPOINT_XS}px) {
    display: flex;
    justify-content: center;
  }
`

class SashecAdvertPositionWrapper extends Component {
  shouldComponentUpdate () {
    return false
  }

  render () {
    const {
      widget: {
        meta: {
          wrapper: {
            id,
            className
          },
          pos,
          targetId,
          size
        }
      }
    } = this.props

    const cookie = new Cookie()

    return (
      <Row>
        <Col>
          <SashecAdvertPosition className={className} id={id}>
            <AdvertSignWrapper/>
            <SashecAdvert id={targetId} size={size} pos={pos} async={!cookie.isSet('ecoadb')}/>
          </SashecAdvertPosition>
        </Col>
      </Row>
    )
  }
}

SashecAdvertPositionWrapper.propTypes = {
  widget: PropTypes.shape({
    meta: PropTypes.shape({
      wrapper: PropTypes.shape({
        id: PropTypes.string,
        className: PropTypes.string
      }),
      targetId: PropTypes.string.isRequired,
      pos: PropTypes.number.isRequired,
      size: PropTypes.array.isRequired,
      sticky: PropTypes.bool
    })
  })
}

export default SashecAdvertPositionWrapper
